export default __webpack_public_path__ + "static/media/Strifescar Bracers.2b41ba26.jpg";